
 function formatBoolean(value: boolean): string {
  if (value === true) return "True"
  return ""
 }


export const ActionTrackerValidationColumn = (pseLabel: string):any => [
  {
    accessorKey: 'tag',
    header: 'Unique ID',
    size: 40,
  },
  {
    accessorKey: 'is_action_synced',
    header: 'Is Action Synced',
    size: 40,
  },
  {
    accessorKey: 'asset',
    header: 'Asset*',
    size: 60,
  },
  {
    accessorKey: 'barriers',
    header: pseLabel,
    size: 40,
  },
  {
    accessorKey: 'barrier_status_value',
    header: 'Barrier Status*',
    size: 40,
  },
  {
    accessorKey: 'metric',
    header: 'Metric',
    size: 40,
  },
  {
    accessorKey: 'metric_description',
    header: 'Metric Description**',
    size: 40,
  },
  {
    accessorKey: 'finding',
    header: 'Action Finding',
    size: 40,
  },
  {
    accessorKey: 'action',
    header: 'Actions*',
    size: 40,
  },
  {
    accessorKey: 'event',
    header: 'Event',
    size: 40,
  },
  {
    accessorKey: 'location',
    header: 'Location',
    size: 40,
  },
  {
    accessorKey: 'priority_value',
    header: 'Priority',
    size: 40,
  },
  {
    accessorKey: 'assigned_to',
    header: 'Assigned to',
    size: 40,
  },
  {
    accessorKey: 'due_date',
    header: 'Due Date',
    size: 40,
  },
  {
    accessorKey: 'status_value',
    header: 'Status',
    size: 40,
  },
  {
    accessorKey: 'progress_percent',
    header: 'Percentage',
    size: 40,
  },
  {
    accessorKey: 'completed_at',
    header: 'Completed Date',
    size: 40,
  },
  {
    accessorKey: 'comments',
    header: 'Comments',
    size: 40,
  },
  {
    accessorKey: 'attachments',
    header: 'Attachments',
    size: 40,
  }
]

export const ActionTrackerColumns =  (PSELabel: string) => ({
  "Action Management": ActionTrackerValidationColumn(PSELabel) as any,
})